<template>
  <component
    :is="networkTag"
    role="link"
    tabindex="0"
    :data-link="isPopup ? '#share-' + networkName : createSharingUrl(networks[network])"
    :data-action="isPopup ? null : networkAction"
    @keydown.space.prevent
    @keyup.space="share(network, isPopup)"
    @keydown.enter="share(network, isPopup)"
    @click.prevent="share(network, isPopup)"
  >
    <slot></slot>
  </component>
</template>
<script>
export default {
  name: 'social-sharing-network',
  props: {
    networkTag: {
      type: String,
      default: 'span',
    },
    networks: {
      type: Object,
      required: true,
    },
    network: {
      type: String,
      required: true,
    },
    share: {
      type: Function,
      required: true,
    },
    createSharingUrl: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isPopup: this.networks[this.network].type === 'popup',
      networkName: this.networks[this.network].name,
      networkAction: this.networks[this.network].action,
    };
  },
};
</script>
